module.exports = __webpack_public_path__ + "img/a-010.prt.cf11dc44.jpg";